import request from './request.js';
import Servers from '@config'

export default {
  fetchVoucherList: request.get(Servers.oss + '/mall/client/vouchers')
}